/**
 * resolveMatchOutcome — Victory when a nexus reaches 0 HP (P3-05).
 * Pure: no DOM / Three.js. First dead nexus decides the match.
 */
export function resolveMatchOutcome(structures) {
  const peers = Array.isArray(structures) ? structures : [];
  const deadNexus = peers.find((s) => s && s.type === 'nexus' && s.isDead);
  if (!deadNexus) {
    return {
      ended: false,
      winnerTeam: null,
      loserTeam: null,
      destroyedNexusId: null
    };
  }
  const loserTeam = deadNexus.team;
  const winnerTeam = loserTeam === 'blue' ? 'red' : 'blue';
  return {
    ended: true,
    winnerTeam,
    loserTeam,
    destroyedNexusId: deadNexus.id || null
  };
}

/**
 * Player-facing result vs local team (P3-15 banner copy).
 */
export function resolvePlayerMatchResult(outcome, playerTeam) {
  if (!outcome || !outcome.ended) {
    return { kind: 'ongoing', title: null };
  }
  if (outcome.winnerTeam === playerTeam) {
    return { kind: 'victory', title: 'VICTORIA' };
  }
  return { kind: 'defeat', title: 'DERROTA' };
}
